import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ManagePermissionsComponent } from '../../components/manage-permissions/manage-permissions.component';
import { IProfile } from '@app/shared/interfaces';
import { ProfilesService } from '../../services/profiles/profiles.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.sass'],
})
export class PermissionsComponent implements OnInit {
  profiles: IProfile[];
  backUrl: string;
  searchQuery: any;

  constructor(
    private dialog: MatDialog,
    private profileService: ProfilesService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const url = this.router.url;
    let prefix = '';

    if (url.includes('tvf')) {
      prefix = 'tvf';
    } else if (url.includes('ips')) {
      prefix = 'ips';
    } else {
      prefix = 'ips';
    }

    this.backUrl = `/${prefix}/acessos/usuarios`;
    this.fetchProfiles();
  }
  fetchProfiles(): void {
    this.profileService.getProfiles().subscribe({
      next: (response) => {
        this.profiles = response;
      },
      error: (error) => {
        this.toastr.error(error?.errors.join(', '));
      },
    });
  }

  handleOpenModalManage(): void {
    const dialogRef = this.dialog.open(ManagePermissionsComponent, {
      data: { roles: [], attributes: [] },
      panelClass: 'no-padding-dialog',
      minWidth: '40%',
      maxWidth: '90%',
      minHeight: '90%',
      height: '80%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.up === true) {
        this.fetchProfiles();
      }
    });
  }
}
